import { render } from "./ReceiptPrint.vue?vue&type=template&id=48f5fa29&scoped=true"
import script from "./ReceiptPrint.vue?vue&type=script&lang=js"
export * from "./ReceiptPrint.vue?vue&type=script&lang=js"

import "./ReceiptPrint.vue?vue&type=style&index=0&id=48f5fa29&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Gerente de TI\\Downloads\\temp\\JB\\new-project\\jb-ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48f5fa29"]])

export default __exports__